import { useState, useEffect, useContext, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Msg, Button } from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Http from 'services/http2';
import User from 'services/user2';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import CompanyService from 'services/company2';
//审批流状态
import WorkflowStatus from 'components/workflowStatus.jsx';
//审批流按钮
import WorkflowButtons from 'components/workflowButtons.jsx';
import Util from 'lib/util.js';
import useDetail from 'hooks/useDetail';
import EnumService from 'services/enum2';
import InquiryService from 'services/inquiry';
import { ActionContext } from 'actions/context';
import Modal from 'components/modal';
import CommonFns from 'functions/common.ts';
import Big from 'big.js';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InfoIcon from '@material-ui/icons/Info';
import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import OrderLogList from 'components/orderLogList';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import BodydCustField from 'components/bodyCustField';
import Public from '../public';
import CustFieldService from 'services/custField';

function InquiryBidDetail(props) {
  const Config = {
    purchase: {
      title: '供应商竞价详情',
      apiPath: '/bidding/getDetail',
      publishApiPath: '/bidding/publish',
      cancelApiPath: '/bidding/cancel',
      puResultApiPath: '/bidding/publishResult',
      confirmCuBidApiPath: '/cbidding/biddingChoose',
      enumMainKey: 'B02_Bid_Status',
      companyNameKey: 'innerVendorName',
      custFieldBillType: 55, //自定义字段单别
      detailLink: '/mp/purchase/inquiry/prod/quote/detail',
      arrEnumField: [
        {
          mainKey: 'B02_Bid_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'bidXkNo',
      wfmCode: '1007'
    },
    sale: {
      title: '客户竞价详情',
      apiPath: '/cbidding/getDetail',
      enumMainKey: 'B02_Bid_Status',
      custFieldBillType: 55, //自定义字段单别
      companyNameKey: 'innerCustomerName',
      confirmCuBidApiPath: '/cbidding/biddingChoose',
      detailLink: '/mp/sale/inquiry/prod/quote/detail',
      addLink: '/mp/sale/inquiry/prod/quote/add',
      quPriceBidApiPath: '/cbidding/quote/add',
      giveUpBidApiPath: '/cbidding/quote/giveUpBid',
      arrEnumField: [
        {
          mainKey: 'B02_Bid_Status',
          subKey: 'status',
          value: 'statusName'
        }
      ],
      idField: 'bidXkNo'
    }
  };

  const { state, dispatch } = useContext(ActionContext);
  const config = Config[props.type];
  config.dispatch = dispatch;

  const {
    companyCode,
    inited,
    error,
    updateTs,
    redirect,
    decimalPlace,
    fieldSetting,
    fileList,
    setShowLoading,
    setError,
    setFileList,
    setRedirect,
    detail,
    setDetail,
    workflow,
    forceUpdate,
    self
  } = useDetail(props, config);
  self.idField = 'bidXkNo';
  self.countTimer = 0;
  self.countDownTimer = 0;

  // const { state, dispatch } = useContext(ActionContext);
  const [boxState, setBoxState] = useState({
    1: true
  });

  const [currentBidInfo, setCurrentBidInfo] = useState({});
  const [vendorQuoteList, setVendorQuoteList] = useState([]);
  const [myQuoteList, setMyQuoteList] = useState([]);
  const [countDown, setCountDown] = useState();
  const [currNavIndex, setCurrNavIndex] = useState(Number);
  const [quoteBottom, setQuoteBottom] = useState(false);

  const [paramVar, setParamVar] = useState({});
  const [myQuotePrice, setMyQuotePrice] = useState('');
  const [companyParamObj, setCompanyParamObj] = useState({});
  const [taxTypeList, setTaxTypeList] = useState([]);

  //处理详情数据
  self.afterGetDetail = function (data) {
    if (self.isPurchase) {
      data.vendorList.forEach(vendor => {
        EnumService.getValue(
          'B02_Bid_Confirm_Flag',
          vendor.confirmBiddingFlag
        ).then(value => {
          vendor.confirmBiddingFlagName = value;
          forceUpdate();
        });
      });
      //获取企业参数
      CompanyService.getCompanyParamsByCodes(
        [companyCode],
        ['Allow_view_quote_data_while_quoting_in_bid'],
        true
      ).then(res => {
        let companyParams = {};
        res.forEach(row => {
          companyParams[row.paramCode] = row.paramValue;
        });
        setCompanyParamObj(companyParams);
      });
    } else {
      EnumService.getValue(
        'B02_Bid_Confirm_Flag',
        data.confirmBiddingFlag
      ).then(value => {
        data.confirmBiddingFlagName = value;
        forceUpdate();
      });
      getSelectList(data);
    }

    data.taxRateShow = data.taxRate * 100;
    data.priceContainTaxName =
      data.priceContainTaxFlag === 0
        ? '不限'
        : data.priceContainTaxFlag === 1
          ? '含税价'
          : '未税价';
    data.quoteCurrencyName = data.quoteCurrencyName || '人民币'; //默认人民币
    setDetail(data);
    refreshQuoteData(data);
  };

  //初始化默认企业
  useEffect(() => {
    const { match } = props;
    let routeCompanyCode = match.params.companyCode;
    self.init(routeCompanyCode);
    //卸载时
    return function unmount() {
      if (self.toastTimer) {
        clearTimeout(self.toastTimer);
      }
      if (self.loadingTimer) {
        clearTimeout(self.loadingTimer);
      }
      if (self.errorTimer) {
        clearTimeout(self.errorTimer);
      }
      if (refreTimeObj.current) {
        clearInterval(refreTimeObj.current);
      }
    };
  }, [self, props]);

  //根据依赖多次执行
  useEffect(() => {
    self.getDetail();
  }, [companyCode, self]);

  function handleBoxState(idx) {
    boxState[idx] = !boxState[idx];
    setBoxState(boxState);
    forceUpdate();
  }

  // 获取参数列表（税别）
  function getSelectList(detailData) {
    let postbodyTaxType = {
      apiPath: '/archives/compTaxType/getListByCompCode',
      companyCode: detailData.customerCode
    };

    let arrPromise = [Http.post('/api/cloudCenter', postbodyTaxType)];

    Promise.all(arrPromise).then(arrResponse => {
      let responseTax = arrResponse[0]; // 税别
      let taxTypeList1 = [];

      if (responseTax.success) {
        taxTypeList1 = responseTax.data.map(item => {
          let text = '(' + item.taxCode + ') ' + item.taxName;
          return {
            id: item.taxCode,
            name: item.taxName,
            text: text,
            taxRate: item.taxRate,
            isContainTax: item.isContainTax,
            taxName: item.taxName
          };
        });
      }
      setTaxTypeList(taxTypeList1);
    });
  }

  //获取提交参数
  function getPostbody(apiPath) {
    let postbody = {
      bidXkNo: detail.bidXkNo,
      companyCode: companyCode,
      apiPath: apiPath
    };
    return postbody;
  }

  // 切换tab
  function handleNav(event, type) {
    setCurrNavIndex(Number(type));
    if (Number(type) === 1) {
      refreshQuoteData(detail);
    } else {
      clearInterval(self.countTimer);
      clearInterval(self.countDownTimer);
    }
  }

  let refreTimeObj = useRef();

  // 项目竞价
  function refreshQuoteData(data) {
    clearInterval(self.countTimer);
    clearInterval(self.countDownTimer);
    clearInterval(refreTimeObj.current);

    let fn = async () => {
      if (self.isPurchase) {
        if (!data.lastQueryTime) {
          getCurrentBidInfo(data);
          getQuoteDetail(data);
        }
        if (await getIsHaveNewQuote(data)) {
          clearInterval(self.countDownTimer);
          getCurrentBidInfo(data);
          getQuoteDetail(data);
          initCountDown();
        }

        // getCurrentBidInfo();
        // getQuoteDetail();
      } else {
        // getMyQuoteList(data);
        // getCurrentBidInfoSale(data);
        // getQuoteDetailSale(data);

        if (!data.lastQueryTime) {
          getMyQuoteList(data);
          getCurrentBidInfoSale(data);
          getQuoteDetailSale(data);
        }
        if (await getIsHaveNewQuote(data)) {
          clearInterval(self.countDownTimer);
          getMyQuoteList(data);
          getCurrentBidInfoSale(data);
          getQuoteDetailSale(data);
        }
      }
    };
    if (detail.status !== 1) {
      fn();
    }
    if (detail.status === 2) {
      initCountDown();
      refreTimeObj.current = setInterval(fn, 1000);
    }
  }

  // 获取当前价格统计
  function getCurrentBidInfo(detailData) {
    let postbody = {
      bidXkNo: detailData.bidXkNo,
      bidLineNo: 1,
      companyCode: companyCode,
      apiPath: '/bidding/quote/currentBidInfo'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      let format = n => {
        let prefix = n > 0 ? '+' : '';
        return prefix + n.toFixed(0) + '%';
      };
      if (response.success) {
        let data = response.data || {};
        let n;
        if (data.currMinPrice !== null && data.histoMinPrice !== null) {
          n =
            ((data.currMinPrice - data.histoMinPrice) / data.histoMinPrice) *
            100;
          data.percentMin = format(n);
          data.deltaMin = data.currMinPrice - data.histoMinPrice;
        }
        if (data.currAvgPrice !== null && data.histoAvgPrice !== null) {
          n =
            ((data.currAvgPrice - data.histoAvgPrice) / data.histoAvgPrice) *
            100;
          data.percentAvg = format(n);
          data.deltaAvg = data.currAvgPrice - data.histoAvgPrice;
        }
        if (data.currMaxPrice !== null && data.histoMaxPrice !== null) {
          n =
            ((data.currMaxPrice - data.histoMaxPrice) / data.histoMaxPrice) *
            100;
          data.percentMax = format(n);
          data.deltaMax = data.currMaxPrice - data.histoMaxPrice;
        }

        if (data.bidEndDate) {
          detail.bidEndDate = data.bidEndDate;
        }

        setCurrentBidInfo(data);
      }
    });
  }

  // 获取报价详情
  function getQuoteDetail(data) {
    let postbody = {
      bidXkNo: data.bidXkNo,
      callerType: 1,
      companyCode: companyCode,
      apiPath: '/bidding/quote/getQuoteDetail'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let arr = response.data || [];
        //[比价中，已完成]
        if ([4, 5].includes(data.status)) {
          //根据最终价格排序
          let list = arr
            .filter(item => item.quoteList !== null)
            .sort((a, b) => b.createtime - a.createTime)
            .sort(
              (a, b) => a.quoteList[0].quotePrice - b.quoteList[0].quotePrice
            );

          genFinalQuoteList(list);
          setVendorQuoteList(list);
        } else if (data.status === 2) {
          setVendorQuoteList(arr);
        }
      }
    });
  }

  // 获取我的报价列表（供应商）
  function getMyQuoteList(data) {
    let postbody = {
      bidXkNo: data.bidXkNo,
      companyCode: companyCode,
      apiPath: '/cbidding/quote/myQuoteList'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data || [];
        setMyQuoteList(list);
      }
    });
  }

  // 获取当前价格统计（供应商）
  function getCurrentBidInfoSale(detailData) {
    let postbody = {
      bidXkNo: detailData.bidXkNo,
      bidLineNo: 1,
      companyCode: companyCode,
      apiPath: '/cbidding/quote/currentBidInfo'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let data = response.data || {};

        if (data.bidEndDate) {
          detail.bidEndDate = data.bidEndDate;
        }

        setCurrentBidInfo(data);
      }
    });
  }
  // 获取报价详情（供应商）
  function getQuoteDetailSale(data) {
    let postbody = {
      bidXkNo: data.bidXkNo,
      callerType: 2,
      companyCode: companyCode,
      apiPath: '/bidding/quote/getQuoteDetail'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data || [];
        list.forEach(item => {
          item.isSelf = item.vendorCode === self.companyCode;
        });
        setVendorQuoteList(list);
      }
    });
  }
  //生成最终报价数据
  function genFinalQuoteList(list) {
    let total = 0;
    let arr = list
      .filter(vendor => vendor.quoteList !== null)
      .map(vendor => {
        let quoteList = vendor.quoteList
          .slice(0)
          .sort((a, b) => b.createTime - a.createTime);
        let { quotePrice } = quoteList[0];
        total += quotePrice;
        return {
          quotePrice: '',
          createName: '',
          vendorCode: '',
          avgPrice: 0,
          checked: vendor.quoteSelectedFlag === 1,
          innerVendorName: vendor.innerVendorName,
          vendorXkUniqueCode: vendor.vendorXkUniqueCode
        };
      });
    arr.sort((a, b) => a.quotePrice - b.quotePrice);
  }

  // 修改初始化倒计时函数
  function initCountDown() {
    clearInterval(self.countTimer);
    clearInterval(self.countDownTimer);
    // clearInterval(refreTimeObj.current);

    // 增加时间有效性校验
    const endDate = new Date(detail.bidEndDate);
    if (!endDate || isNaN(endDate)) {
      return;
    }

    let delta = endDate.getTime() - Date.now();
    if (delta <= 0) {
      setCountDown('00 : 00 : 00');
      return;
    }

    delta = Math.floor(delta / 1000);

    const padZero = n => n.toString().padStart(2, '0');

    // 使用函数式更新确保获取最新状态
    const updateFn = () => {
      setCountDown(prev => {
        const newDelta = Math.floor(
          (new Date(detail.bidEndDate).getTime() - Date.now()) / 1000
        );
        if (newDelta <= 0) {
          clearInterval(self.countDownTimer);
          return '00 : 00 : 00';
        }

        const h = Math.floor(newDelta / 3600);
        const m = Math.floor((newDelta % 3600) / 60);
        const s = newDelta % 60;
        return `${padZero(h)} : ${padZero(m)} : ${padZero(s)}`;
      });
    };

    // 立即执行并启动定时器
    updateFn();
    self.countDownTimer = setInterval(updateFn, 1000);
  }

  // 监听 bidEndDate 变化
  useEffect(() => {
    const timerRef = self.countDownTimer;
    const refreshRef = refreTimeObj.current;

    return () => {
      // 组件卸载时清除定时器
      clearInterval(timerRef);
      clearInterval(refreshRef);
    };
  }, [self.countDownTimer, detail.bidEndDate]);

  // 修改报价信息
  function handleQuoteChange(event) {
    let val = Util.qtyChange(event.target.value);
    setMyQuotePrice(val);
    forceUpdate();
    calculatePrice(val);
  }

  //修改税别
  function handleTaxTypeChange(event) {
    let val = event.target.value;
    let obj = paramVar;
    obj['taxCode'] = val;
    taxTypeList.forEach(item => {
      if (item.id === val) {
        obj['taxName'] = item.taxName;
        obj['isTaxRate'] = item.taxRate;
        obj['taxRate'] = item.taxRate;
        obj['taxRateShow'] = item.taxRate * 100;
        obj['isContainTax'] = item.isContainTax;
        obj['priceContainTaxFlag'] = item.isContainTax === 1 ? 1 : 2;
        obj['priceContainTaxName'] =
          obj.priceContainTaxFlag === 0
            ? '不限'
            : obj.priceContainTaxFlag === 1
              ? '含税价'
              : '未税价';
      }
    });
    setParamVar({
      quotePrice: myQuotePrice,
      isBackTxtError: false,
      isBackTxtError2: false,
      quotePriceTax: paramVar.quotePriceTax,
      quotePriceNoTax: paramVar.quotePriceNoTax,
      taxCode: obj.taxCode,
      taxName: obj.taxName,
      isContainTax: obj.isContainTax,
      taxRate: obj.taxRate
    });
    forceUpdate();
    calculatePrice(myQuotePrice);
  }

  //计算项次的含税单价和未税单价
  function calculatePrice(val) {
    let quotePrice = val;
    let taxRate = paramVar.taxRate || 0;
    if (!Util.isEmpty(quotePrice) && Util.isBig(quotePrice, taxRate)) {
      if (paramVar.isContainTax === 0) {
        paramVar.quotePriceNoTax = quotePrice;
        paramVar.quotePriceTax =
          Big(parseFloat(paramVar.quotePriceNoTax))
            .times(Big(taxRate).plus(1))
            .valueOf() || 0;
        paramVar.quotePriceTax = Big(paramVar.quotePriceTax).toFixed(8);
      } else {
        paramVar.quotePriceTax = quotePrice;
        paramVar.quotePriceNoTax =
          Big(parseFloat(paramVar.quotePriceTax))
            .div(Big(taxRate).plus(1))
            .valueOf() || 0;
        paramVar.quotePriceNoTax = Big(paramVar.quotePriceNoTax).toFixed(8);
      }
    } else {
      paramVar.quotePriceTax = 0;
      paramVar.quotePriceNoTax = 0;
    }
    setParamVar({
      ...paramVar,
      quotePrice: quotePrice,
      isBackTxtError: false,
      isBackTxtError2: false,
      quotePriceTax: paramVar.quotePriceTax,
      quotePriceNoTax: paramVar.quotePriceNoTax,
      taxCode: paramVar.taxCode,
      taxName: paramVar.taxName,
      isContainTax: paramVar.isContainTax,
      taxRate: paramVar.taxRate
    });
    forceUpdate();
  }

  // 确定报价按钮
  function sureQuoteClick() {
    let lastPrice =
      myQuoteList.length > 0 ? myQuoteList[0].quotePrice : Infinity;
    if (/^\d+(\.\d+)?$/.test(myQuotePrice) === false) {
      setParamVar({
        quotePrice: myQuotePrice,
        isBackTxtError: true,
        isBackTxtError2: false,
        quotePriceTax: paramVar.quotePriceTax,
        quotePriceNoTax: paramVar.quotePriceNoTax,
        taxCode: paramVar.taxCode,
        taxName: paramVar.taxName,
        isContainTax: paramVar.isContainTax,
        taxRate: paramVar.taxRate
      });
      return;
    }
    if (detail.quoteLessFlag === 1 && parseFloat(myQuotePrice) >= lastPrice) {
      setParamVar({
        quotePrice: myQuotePrice,
        isBackTxtError: false,
        isBackTxtError2: true,
        quotePriceTax: paramVar.quotePriceTax,
        quotePriceNoTax: paramVar.quotePriceNoTax,
        taxCode: paramVar.taxCode,
        taxName: paramVar.taxName,
        isContainTax: paramVar.isContainTax,
        taxRate: paramVar.taxRate
      });
      return;
    }
    handle('quotePrice');
  }

  function handle(type) {
    switch (type) {
      case '1':
        confirmCustomerBidding(1);
        break;
      case '2':
        confirmCustomerBidding(2);
        break;
      case '3':
        publishBidding();
        break;
      case '4':
        cancelBidding();
        break;
      case '5':
        publishResult();
        break;
      case 'quotePrice':
        quotePriceBidding();
        break;
      default:
    }
  }

  // 发布竞价
  function publishBidding() {
    let postbody = getPostbody(config.publishApiPath);
    InquiryService.publishBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 取消竞价
  function cancelBidding() {
    let postbody = getPostbody(config.cancelApiPath);
    InquiryService.cancelBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 发布竞价结果
  function publishResult() {
    let postbody = getPostbody(config.puResultApiPath);
    InquiryService.publishResult(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }
  // 供应商确认竞价 || 放弃
  function confirmCustomerBidding(type) {
    let postbody = getPostbody(config.confirmCuBidApiPath);
    postbody.confirmBiddingFlag = type;
    InquiryService.confirmCustomerBidding(
      postbody,
      () => {
        self.getDetail();
      },
      dispatch
    );
  }

  //当前竞价统计信息（供应商）
  function getBidStatistics(data) {
    let postbody = {
      bidXkNo: data.bidXkNo,
      companyCode: companyCode,
      apiPath: '/cbidding/quote/currentBidStatistics'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let list = response.data.respList || [];
        if (list?.length) {
          data.prodList.forEach(prod => {
            prod.currQuoteList = list.filter(
              item => item.lineNo === prod.lineNo
            )[0];
            let fieldList = [
              'rank',
              'currMinPrice',
              'lastPrice',
              'taxName',
              'taxPrice',
              'unTaxPrice',
              'vendorDescription',
              'quoteSelectedFlag',
              'priceSize'
            ];
            for (let i = 0; i < fieldList.length; i++) {
              if (prod.currQuoteList) {
                prod[fieldList[i]] = prod.currQuoteList[fieldList[i]];
              }
            }
          });
          setDetail(data);
        }
      }
    });
  }

  //打开报价弹窗初始化数据
  function setDate(item) {
    setQuoteBottom(true);
    let obj = {};
    if (!Util.isEmpty(myQuoteList)) {
      obj = {
        taxCode: myQuoteList[0].taxCode,
        taxName: myQuoteList[0].taxName,
        isContainTax: myQuoteList[0].isContainTax,
        taxRate: myQuoteList[0].taxRate
      };
    } else {
      let isContainTax = 1;
      if (taxTypeList.some(tax => tax.id === detail.taxCode)) {
        isContainTax = taxTypeList.filter(tax => tax.id === detail.taxCode)[0]
          .isContainTax;
      }
      obj = {
        taxCode: detail.taxCode,
        taxName: detail.taxName,
        isContainTax: isContainTax,
        taxRate: detail.taxRate
      };
    }
    setMyQuotePrice(0);

    setParamVar({
      ...item,
      quotePrice: myQuotePrice,
      isBackTxtError: false,
      isBackTxtError2: false,
      quotePriceTax: 0,
      quotePriceNoTax: 0,
      taxCode: obj.taxCode,
      taxName: obj.taxName,
      isContainTax: obj.isContainTax,
      taxRate: obj.taxRate
    });
  }

  // 报价
  function quotePriceBidding() {
    let postbody = getPostbody(config.quPriceBidApiPath);
    postbody.bidLineNo = 1;
    postbody.quotePrice = myQuotePrice;
    postbody.taxCode = paramVar.taxCode;
    postbody.taxName = paramVar.taxName;
    postbody.taxRate = paramVar.taxRate;
    postbody.isContainTax = paramVar.isContainTax;

    let bodyData = CustFieldService.getBodyData(
      fieldSetting,
      paramVar,
      self.isPurchase
    );

    CustFieldService.parseCustFields(
      fieldSetting,
      undefined,
      [bodyData],
      self.isPurchase
    );

    if (
      !CustFieldService.validate(
        undefined,
        [bodyData],
        fieldSetting,
        false,
        dispatch
      )
    ) {
      return;
    }

    Object.assign(postbody, bodyData);

    InquiryService.quotePriceBidding(
      postbody,
      () => {
        // self.getDetail();
        setMyQuotePrice('');
        setQuoteBottom(false);
        refreshQuoteData(detail);
      },
      dispatch
    );
  }

  //放弃竞价
  function giveUpBidding() {
    let postbody = getPostbody(config.giveUpBidApiPath);
    postbody.bidLineNo = 1;
    InquiryService.giveUpBidding(
      postbody,
      () => {
        setMyQuotePrice('');
        setQuoteBottom(false);
        refreshQuoteData(detail);
      },
      dispatch
    );
  }

  //获取当前价格统计
  async function getIsHaveNewQuote(data) {
    if (!data.lastQueryTime) {
      data.lastQueryTime = Public.getServerTime();
    }

    let time = data.lastQueryTime || Public.getServerTime();

    let haveNewQuote = false;
    let postbody = {
      bidXkNo: data.bidXkNo,
      lastQueryTime: time,
      bidEndDate: data.bidEndDate,
      companyCode: self.isPurchase ? companyCode : data.customerCode,
      apiPath: '/bidding/quote/getIsHaveNewQuote'
    };
    await Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        haveNewQuote = response.data;
        data.lastQueryTime = response.curServerTime;
        setDetail(data);
      }
    });
    return haveNewQuote;
  }

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }

  return (
    <div>
      <TopNav inited={inited} />
      {detail.status > 1 && (
        <Paper square={true} style={{ marginBottom: '5px' }}>
          <Tabs
            value={currNavIndex}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleNav}
          >
            <Tab label="项目信息" />
            {((self.isPurchase &&
              companyParamObj['Allow_view_quote_data_while_quoting_in_bid'] ===
                '1' &&
              User.checkAuth('10070315') &&
              detail.status === 2) ||
              (self.isPurchase &&
                [4, 5, 6, 8, 7, 9].indexOf(detail.status) !== -1) ||
              (!self.isPurchase &&
                detail.confirmBiddingFlag === 1 &&
                [1, 2, 4, 5].includes(detail.status))) && (
              <Tab label={'项目竞价(' + detail.statusName + ')'} />
            )}

            <Tab label="操作记录" />
          </Tabs>
        </Paper>
      )}
      {currNavIndex === 0 && (
        <div className="m-details-container">
          <div className="m-details-item">
            <div className="details-item-title">
              <label>基础信息</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">标题</span>
                    <div className="field-value">{detail.billTitle}</div>
                  </li>
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">客户</span>
                      <div className="field-value">
                        {detail.innerCustomerName}
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">竞价状态</span>
                    <div className="field-value">
                      <span
                        className={
                          'u-sign ' +
                          CommonFns.getStatusClass(
                            'B02_Bid_Status',
                            detail.status
                          )
                        }
                      >
                        {detail.statusName}
                      </span>
                    </div>
                  </li>
                  {/* 审批流状态 仅开启后才显示 */}
                  {workflow.isActive && (
                    <li>
                      <span className="field-label">审批环节</span>
                      <div className="field-value">
                        <WorkflowStatus
                          companyCode={companyCode}
                          id={self.id}
                          workflow={workflow}
                          detail={detail}
                        />
                      </div>
                    </li>
                  )}
                  {/* 审批流按钮 */}
                  {self.isPurchase && workflow.isActive && (
                    <li>
                      <span className="field-label">审批操作</span>
                      <div className="field-value">
                        <WorkflowButtons
                          companyCode={companyCode}
                          id={detail.bidXkNo}
                          workflow={workflow}
                          detail={detail}
                          onChange={() => {
                            self.getDetail();
                          }}
                        />
                      </div>
                    </li>
                  )}
                  {!self.isPurchase && (
                    <li>
                      <span className="field-label">确认状态</span>
                      <div className="field-value">
                        <span
                          className={
                            detail.confirmBiddingFlag === 1
                              ? 'green'
                              : detail.confirmBiddingFlag === 2
                                ? 'red'
                                : ''
                          }
                        >
                          {detail.confirmBiddingFlagName}
                        </span>
                      </div>
                    </li>
                  )}
                  <li>
                    <span className="field-label">发布时间</span>
                    <div className="field-value">
                      {formatDate(detail.publishTime, 'YYYY-MM-DD HH:mm:ss')}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">发布人</span>
                    <div className="field-value">{detail.publishName}</div>
                  </li>
                  <li>
                    <span className="field-label">编号</span>
                    <div className="field-value">{detail.bidXkNo}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>竞价项目设定</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">竞价有效时间</span>
                    <div className="field-value">
                      <span className="blue">
                        {formatDate(detail.bidStartDate, 'YYYY-MM-DD HH:mm')} -{' '}
                        {formatDate(detail.bidEndDate, 'YYYY-MM-DD HH:mm')}
                      </span>
                    </div>
                  </li>
                  {self.isPurchase && (
                    <li>
                      <span className="field-label">竞价控制</span>
                      <div className="field-value">
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showRankingsFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示排名"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showMaxPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示最高报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showMinPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示最低报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showAveragePriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示平均报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showVendorPriceFlag === 1 ? true : false
                              }
                            />
                          }
                          label="竞价时公示其他供应商报价"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.showOtherVendorNameFlag === 1
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="竞价时公示其他供应商名称"
                        />
                        <FormControlLabel
                          disabled
                          control={
                            <Checkbox
                              checked={
                                detail.quoteLessFlag === 1 ? true : false
                              }
                            />
                          }
                          label="报价时价格必须低于上次报价"
                        />
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>竞价物料</label>
            </div>
            <div className="details-item-content">
              {!Util.isEmpty(detail.prodList) &&
                detail.prodList.map((item, index) => (
                  <div
                    className="content-line line-list-item"
                    key={String(item.id) + index}
                  >
                    <div className="line-list-item-title">
                      <span>项次 {item.lineNo}</span>
                    </div>
                    <ul className="field-list">
                      <li>
                        <span className="field-label">物料编码</span>
                        <div className="field-value">{item.productCode}</div>
                      </li>
                      <li>
                        <span className="field-label">物料名称</span>
                        <div className="field-value">{item.productName}</div>
                      </li>
                      <li>
                        <span className="field-label">物料规格</span>
                        <div className="field-value">{item.productScale}</div>
                      </li>
                      <li>
                        <span className="field-label">采购数量</span>
                        <div className="field-value">
                          {formatNumber(
                            item.purchaseQty,
                            decimalPlace.Quantity_Decimal_Place
                          )}{' '}
                          {item.purchaseUnitName}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">采购单位</span>
                        <div className="field-value">{item.unitName}</div>
                      </li>
                      <li>
                        <span className="field-label">需求日期</span>
                        <div className="field-value">
                          {formatDate(item.demandDate, 'YYYY-MM-DD')}
                        </div>
                      </li>
                      <li>
                        <span className="field-label">相关说明</span>
                        <div className="field-value">{item.description}</div>
                      </li>
                    </ul>
                  </div>
                ))}
            </div>
          </div>

          <div className="m-details-item">
            <div className="details-item-title">
              <label>报价要求</label>
            </div>
            <div className="details-item-content">
              <div className="content-line">
                <ul className="field-list">
                  <li>
                    <span className="field-label">付款方式</span>
                    <div className="field-value">{detail.payWayName}</div>
                  </li>
                  <li>
                    <span className="field-label">付款周期</span>
                    <div className="field-value">{detail.paymentCycleName}</div>
                  </li>
                  <li>
                    <span className="field-label">报价币别</span>
                    <div className="field-value">
                      {detail.quoteCurrencyName}
                    </div>
                  </li>
                  <li>
                    <span className="field-label">是否含税</span>
                    <div className="field-value">
                      {detail.priceContainTaxName}
                    </div>
                  </li>
                  {detail.priceContainTaxFlag && detail.taxRate ? (
                    <li>
                      <span className="field-label">税率</span>
                      <div className="field-value">{detail.taxRateShow}%</div>
                    </li>
                  ) : (
                    ''
                  )}
                  <li>
                    <span className="field-label">竞价说明</span>
                    <div className="field-value">{detail.description}</div>
                  </li>
                  {detail.description && (
                    <li>
                      <div className="field-value">
                        <div className="quoProductsList wid100">
                          <InfoIcon
                            className="verticalMiddle mr5"
                            color="primary"
                            fontSize="small"
                          />
                          参与竞价即代表已经同意上述报价要求
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
          {self.isPurchase && (
            <div className="m-details-item">
              <div className="details-item-title">
                <label>竞价供应商</label>
              </div>
              <div className="details-item-content">
                {!Util.isEmpty(detail.vendorList) &&
                  detail.vendorList.map((item, index) => (
                    <div className="content-line line-list-item" key={index}>
                      <div className="line-list-item-title">
                        <span>
                          {item.innerVendorCode}-{item.innerVendorName}
                        </span>
                      </div>
                      <ul className="field-list">
                        <li>
                          <span className="field-label">类型</span>
                          <div className="field-value">
                            {item.newFlag === 0
                              ? '正式供应商'
                              : item.newFlag === 2
                                ? '潜在供应商'
                                : ''}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">平台名称</span>
                          <div className="field-value">
                            {item.handshakeFlag !== 2 && item.vendorName}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">平台状态</span>
                          <div className="field-value">
                            {item.handshakeFlag === 2 ? '已加入' : '未加入'}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">竞价确认</span>
                          <div className="field-value">
                            {item.confirmBiddingFlagName}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">接收人</span>
                          <div className="field-value">
                            {item.handshakeFlag === 2
                              ? '将自动于携客平台内通知'
                              : item.contactPerson}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">手机号码</span>
                          <div className="field-value">
                            {item.mobile ? item.mobileArea : ''} {item.mobile}
                          </div>
                        </li>
                        <li>
                          <span className="field-label">邮箱</span>
                          <div className="field-value">{item.mailbox}</div>
                        </li>
                      </ul>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      )}
      {currNavIndex === 1 && (
        <div className="pb50">
          <div className="order-detail-block">
            {detail.status === 1 && (
              <div className="order-detail-title orange">
                未开始
                <p>
                  开始时间:{' '}
                  {formatDate(detail.bidStartDate, 'YYYY-MM-DD HH:mm:ss')}
                </p>
              </div>
            )}
            {detail.status === 2 && (
              <div className="order-detail-title orange">
                距离竞价截止时间 :<span className="fr">{countDown}</span>
              </div>
            )}
            {[4, 5].includes(detail.status) && (
              <div className="order-detail-title orange">
                已结束:
                <p>
                  结束时间:{' '}
                  {formatDate(detail.bidEndDate, 'YYYY-MM-DD HH:mm:ss')}
                </p>
              </div>
            )}
          </div>
          {self.isPurchase ? (
            <div>
              <div className="order-detail-block">
                <div className="order-detail-title">
                  <label>当前竞价统计</label>
                </div>
                <div className="order-detail-list">
                  <ul>
                    <li className="order-detail-item">
                      <h4>最低报价</h4>
                      <p className="mb10">
                        当前价格：
                        {formatNumber(
                          currentBidInfo.currMinPrice,
                          decimalPlace.Price_Decimal_Place
                        )}
                      </p>
                      <ul className="clearfix">
                        <li>
                          历史价格：
                          {formatNumber(
                            currentBidInfo.histoMinPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </li>
                        <li>降幅：{currentBidInfo.percentMin}</li>
                      </ul>
                    </li>
                    <li className="order-detail-item">
                      <h4>平均报价</h4>
                      <p className="mb10">
                        当前价格：
                        {formatNumber(
                          currentBidInfo.currAvgPrice,
                          decimalPlace.Price_Decimal_Place
                        )}
                      </p>
                      <ul className="clearfix">
                        <li>
                          历史价格：
                          {formatNumber(
                            currentBidInfo.histoAvgPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </li>
                        <li>降幅：{currentBidInfo.percentAvg}</li>
                      </ul>
                    </li>
                    <li className="order-detail-item">
                      <h4>最高报价</h4>
                      <p className="mb10">
                        当前价格：
                        {formatNumber(
                          currentBidInfo.currMaxPrice,
                          decimalPlace.Price_Decimal_Place
                        )}
                      </p>
                      <ul className="clearfix">
                        <li>
                          历史价格：
                          {formatNumber(
                            currentBidInfo.histoMaxPrice,
                            decimalPlace.Price_Decimal_Place
                          )}
                        </li>
                        <li>降幅：{currentBidInfo.percentMax}</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="order-detail-block">
                <div className="order-detail-title">
                  <label>竞价记录</label>
                </div>
                <div className="order-detail-list">
                  <ul>
                    {!Util.isEmpty(vendorQuoteList) &&
                      vendorQuoteList.map((vendor, index) => (
                        <li
                          className="order-detail-item"
                          key={String(vendor.id) + index}
                        >
                          <h4>
                            {vendor.innerVendorName}({vendor.innerVendorCode})
                            <span
                              className={
                                vendor.quoteSelectedFlag === 1
                                  ? 'u-sign green'
                                  : 'u-sign'
                              }
                              style={{ float: 'right' }}
                            >
                              {vendor.quoteSelectedFlag === 1
                                ? '入选'
                                : '未入选'}
                            </span>
                          </h4>
                          {!Util.isEmpty(vendor.quoteList) &&
                            vendor.quoteList.map((item, i) => (
                              <ul
                                className="clearfix"
                                key={String(item.id) + i}
                              >
                                <li>
                                  报价时间：
                                  {formatDate(item.createTime, 'HH:mm:ss')}
                                </li>
                                <li>
                                  竞价记录：
                                  {formatNumber(
                                    item.quotePrice,
                                    decimalPlace.Price_Decimal_Place
                                  )}
                                </li>
                                <li>报价人：{item.createName}</li>
                              </ul>
                            ))}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="order-detail-block">
                <div className="order-detail-title">
                  <label>当前竞价信息</label>
                </div>
                <ul>
                  <li>
                    <label className="order-detail-label">当前排名</label>
                    <div className="order-detail-value">
                      {currentBidInfo.rank}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前最高报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currMaxPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前最低报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currMinPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前平均报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currAvgPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">报价次数</label>
                    <div className="order-detail-value">
                      {currentBidInfo.priceSize}
                    </div>
                  </li>
                </ul>
              </div>
              <div className="order-detail-block">
                <div className="order-detail-title">
                  <label>报价信息</label>
                </div>
                {/* 单身自定义字段 */}
                <BodydCustField
                  fieldSetting={fieldSetting}
                  line={currentBidInfo}
                  isPurchase={self.isPurchase}
                ></BodydCustField>
                {/* <ul>
                  <li>
                    <label className="order-detail-label">当前排名</label>
                    <div className="order-detail-value">
                      {currentBidInfo.rank}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前最高报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currMaxPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前最低报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currMinPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                  <li>
                    <label className="order-detail-label">当前平均报价</label>
                    <div className="order-detail-value">
                      {formatNumber(
                        currentBidInfo.currAvgPrice,
                        decimalPlace.Price_Decimal_Place
                      )}
                    </div>
                  </li>
                </ul> */}
              </div>

              <div className="order-detail-block">
                <div className="order-detail-list">
                  <ul>
                    {!Util.isEmpty(myQuoteList) &&
                      myQuoteList.map((quote, index) => (
                        <li
                          className="order-detail-item"
                          key={String(quote.id) + index}
                        >
                          <h4>
                            {formatDate(
                              quote.createTime,
                              'YYYY-MM-DD HH:mm:ss'
                            )}
                          </h4>
                          <ul className="clearfix">
                            <li>
                              报价价格：
                              {formatNumber(
                                quote.quotePrice,
                                decimalPlace.Price_Decimal_Place
                              )}
                            </li>
                            <li>税别：{quote.taxName}</li>
                            <li>
                              税率：{quote.taxRate ? quote.taxRate * 100 : 0}%
                            </li>
                            <li>报价人：{quote.createName}</li>
                          </ul>
                        </li>
                      ))}
                  </ul>
                  {detail.status === 2 && detail.quoteLessFlag === 1 && (
                    <div className="quoProductsList wid100">
                      <InfoIcon
                        className="verticalMiddle mr5"
                        color="primary"
                        fontSize="small"
                      />
                      报价必须低于上次报价
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {currNavIndex ===
        ([1, 2, 4, 5].includes(detail.status) &&
        (self.isPurchase ||
          (!self.isPurchase && detail.confirmBiddingFlag === 1))
          ? 2
          : 1) && (
        <OrderLogList
          billNo={self.id}
          companyCode={companyCode}
          customerCode={!self.isPurchase ? detail.customerCode : undefined}
        ></OrderLogList>
      )}

      {!self.isPurchase && User.checkAuth('20050302') && (
        <Drawer
          anchor="bottom"
          open={quoteBottom}
          onClose={() => setQuoteBottom(false)}
        >
          <div tabIndex={0} role="button">
            <div className="MuiDrawer-paper">
              <div className="text-field-item">
                <TextField
                  label="我的报价"
                  value={myQuotePrice}
                  onChange={handleQuoteChange}
                  margin="normal"
                  variant="outlined"
                />
                {paramVar.isBackTxtError && (
                  <div className="red">价格格式不正确</div>
                )}
                {paramVar.isBackTxtError2 && (
                  <div className="red">价格必须低于上次报价</div>
                )}
              </div>
              <div className="text-field-item">
                <FormControl fullWidth={true}>
                  <InputLabel>税别：</InputLabel>
                  <Select
                    value={paramVar.taxCode || ''}
                    disabled={
                      !(detail.status === 2 && detail.vendorEditTaxRateFlag)
                    }
                    onChange={event => handleTaxTypeChange(event)}
                    className="select-company-list"
                  >
                    {!Util.isEmpty(taxTypeList) &&
                      taxTypeList.map((item, index) => (
                        <MenuItem key={index} value={item.id}>
                          {item.text}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
              <div className="text-field-item">
                <p>
                  <span>含税价：</span> {paramVar.quotePriceTax}
                </p>
                <p>
                  <span>未税价：</span> {paramVar.quotePriceNoTax}
                </p>
              </div>
              <div className="text-field-item">
                {/* 单身自定义字段 */}
                <BodydCustField
                  fieldSetting={fieldSetting}
                  line={paramVar}
                  bodyCustData={paramVar}
                  setBodyCustData={setParamVar}
                  isEdit={true}
                  isPurchase={self.isPurchase}
                ></BodydCustField>
              </div>
              <p className="mt15 m-flex-box">
                <Button
                  type="default"
                  onClick={() => sureQuoteClick()}
                  className="m-flex-item u-btn u-btn_primary"
                >
                  确定
                </Button>
                <Button
                  type="default"
                  onClick={() => {
                    setParamVar({
                      quotePrice: '',
                      isBackTxtError: false,
                      isBackTxtError2: false
                    });
                    setQuoteBottom(false);
                    setMyQuotePrice('');
                  }}
                  className="m-flex-item u-btn u-btn_line"
                >
                  取消
                </Button>
              </p>
            </div>
          </div>
        </Drawer>
      )}

      {!self.isPurchase &&
        User.checkAuth('20070302') &&
        [1, 2].includes(detail.status) &&
        detail.confirmBiddingFlag === 0 && (
          <div className="wrap m-flex-box fixed-bottom">
            <Button
              type="default"
              onClick={() => {
                handle('1');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认参与
            </Button>
            <Button
              type="default"
              onClick={() => {
                handle('2');
              }}
              className="m-flex-item u-btn u-btn_line"
            >
              本次弃权
            </Button>
          </div>
        )}

      {self.isPurchase && (
        <div className="wrap m-flex-box fixed-bottom">
          {User.checkAuth('10070305') &&
            detail.status === 0 &&
            workflow.data &&
            workflow.data['bidd_publish_2'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handle('3');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布
              </Button>
            )}
          {User.checkAuth('10070304') && [1, 2, 6].includes(detail.status) && (
            <Button
              type="default"
              onClick={() => {
                handle('4');
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              取消竞价
            </Button>
          )}
          {User.checkAuth('10070304') &&
            detail.status === 4 &&
            workflow.data &&
            workflow.data['bidd_cfm_5'].complete && (
              <Button
                type="default"
                onClick={() => {
                  handle('5');
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                发布竞价结果
              </Button>
            )}
        </div>
      )}

      {!self.isPurchase &&
        detail.status === 2 &&
        detail.confirmBiddingFlag === 1 && (
          <div className="wrap m-flex-box fixed-bottom">
            <Button
              type="default"
              onClick={() => {
                setDate(currentBidInfo);
              }}
              className="m-flex-item u-btn u-btn_primary"
            >
              报价
            </Button>
            {User.checkAuth('20070302') && (
              <Button
                type="default"
                onClick={() => {
                  giveUpBidding();
                }}
                className="m-flex-item u-btn u-btn_primary"
              >
                放弃竞价
              </Button>
            )}
          </div>
        )}

      <Modal></Modal>
    </div>
  );
}

InquiryBidDetail.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    data: state.login
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InquiryBidDetail);
